import axiosInstance from "@/utils/axios";
import API from "@/constant/API";
import {string} from "yup";

const appVersion = async () => {
  return await axiosInstance.post(API.APP_VERSION);
}

const countryList = async () => {
  return await axiosInstance.post(API.COUNTRY_LIST);
}

const varietyList = async () => {
  return await axiosInstance.post(API.VARIETY_LIST);
}

// todo: clean up.
const getCodeFromEmail = async (email) => {
  const res = await axiosInstance.post(API.LOGIN_GET_CODE, {
    email
  });
  return res?.data;
}

const emailCodeConfirm = async (email: string, code: string) => {
  return await axiosInstance.post(API.EMAIL_LOGIN, {
    email, code
  });
}

const bindCardToWallet = async (cardId: string) => {
  return await axiosInstance.post(API.CARD_BIND_WALLET, {
    cardId
  });
}

const unbindCardToWallet = async (cardId: string) => {
  return await axiosInstance.post(API.CARD_BIND_WALLET, {
    cardId
  });
}

const modofyCardPin = async (cardId: string, pin: string) => {
  return await axiosInstance.post(API.CARD_CHANGE_PIN, {
    cardId, pin
  });
}

// const setCardPin = async (cardId: string, pin: string) => {
//   return await axiosInstance.post(API.SET_PIN, {
//     cardId, pinCode: pin, pinCodeFirst: pin
//   });
// }

const getUserCardList = async () => {
  return await axiosInstance.post(API.CARD_LIST, {});
}

const getNonce = async (account) => {
  // window.location.host
  return await axiosInstance.post(API.SIWE_NONCE, {
    address: account.address,
    chainId: account.chainId,
    domain: "dapp.rp-2023app.com",
    uri: "https://dapp.rp-2023app.com",
    // uri: "",
  })
}

const toggleFreezeCard = async (cardId: string, isFreeze: boolean) => {
  const url = isFreeze ? API.CARD_UNFREEZE : API.CARD_FREEZE
  return await axiosInstance.post(url, {
    cardId
  });
}

const getCardLimit = async (cardId) => {
  const res = await axiosInstance.post(API.CARD_LIMIT_INFO, {
    cardId
  });
  return res
}

const setCardLimit = async (cardId, single, daily, signature, message) => {
  const params = {
    cardId,
    single,
    daily,
    signature,
    message
  };
  const res = await axiosInstance.post(API.CARD_LIMIT, params);
  return res
}

const getAssetBalance = async () => {
  const res = await axiosInstance.post(API.ASSETS_BALANCE);
  return res
}

const getCardApplyList = async (params: any) => {
  const res = await axiosInstance.post(API.CARD_APPLY_LIST, params)
  return res
}

const cardActivate = async (cardId: string, code: string) => {
  const res = await axiosInstance.post(API.CARD_ACTIVATE, {
    cardId, code
  })
  return res
}

const transferCard = async (cardId: string, sourceChainId: string | number, sourceAddress: string) => {
  const res = await axiosInstance.post(API.CARD_TRANSFER, {
    cardId, sourceChainId, sourceAddress
  })
  return res
}

const requestCardInfo = async (params: any, cardId: string) => {
  const res = await axiosInstance.post(API.CARD_BACK_INFO, {
    ...params,
    cardId
  });
  return res
};

const getUserBalance = async () => {
  const res = await axiosInstance.post(API.BALANCE_V2)
  return res
}

const deleteCard = async (cardId: string) => {
  const res = await axiosInstance.post(API.CARD_DELETE, {cardId})
  return res
}

const getUserInfo = async () => {
  const res = await axiosInstance.post(API.USER_INFO);
  return res
}

const checkBindEmailExist = async (email: string) => {
  const res = await axiosInstance.post(API.BIND_EMAIL_EXIST, {email});
  return res
}

const bindEmail = async (code: string | number, email: string, sign: string) => {
  const res = await axiosInstance.post(API.BIND_EMAIL, {
    code, email, sign
  })
  return res
}

const getMessageList = async (pageNum, pageSize) => {
  const res = await axiosInstance.post(API.MESSAGE_LIST, {pageNum, pageSize})
  return res
}

const getVerifyCodeFromEmail = async (email) => {
  const res = await axiosInstance.post(API.LOGIN_GET_CODE, {
    email
  });
  return res?.data;
}

const getCardBillList = async (params) => {
  const res = await axiosInstance.post(API.CARD_BILL_LIST, params);
  return res;
}

const getCardDetail = async (cardId: string) => {
  const res = await axiosInstance.post(API.CARD_DETAIL, {cardId});
  return res;
}

const reportLostCard = async (cardId: string) => {
  const res = await axiosInstance.post(API.REPORT_LOSS, {cardId});
  return res;
}

const getThemeColors = async () => {
  // const res = await axiosInstance.get('/randy_api/get_theme');
  // return res;
}

const getAlgInfo = async () => {
  const res = await axiosInstance.post(API.GET_ALG_INFO);
  return res;
}

export {
  appVersion,
  countryList,
  varietyList,

  getCodeFromEmail,
  emailCodeConfirm,
  bindCardToWallet,
  unbindCardToWallet,
  modofyCardPin,
  getUserCardList,
  getNonce,
  toggleFreezeCard,
  getCardLimit,
  setCardLimit,
  getAssetBalance,
  getCardApplyList,
  cardActivate,
  transferCard,
  requestCardInfo,
  getUserBalance,
  deleteCard,
  getUserInfo,
  checkBindEmailExist,
  bindEmail,
  getMessageList,
  getVerifyCodeFromEmail,
  getCardBillList,
  getCardDetail,
  reportLostCard,

  getThemeColors,
  // setCardPin
  getAlgInfo
}